/**
 * RCM nested routes.
 */
import { Routes, Route } from 'react-router';
import { RcmLanding } from './RcmLanding';
import { CifDetail } from './CifDetail';

export function RcmRoutes(): JSX.Element {
  return (
    <Routes>
      <Route index element={<RcmLanding />} />
      <Route path=":cifId" element={<CifDetail />} />
      <Route path="*" element={<RcmLanding />} />
    </Routes>
  );
}
